import { AssociatedPartiesItem, associatedPartiesRequestTransformer } from "../api/transformers/associatedParty";
import restUtils from "core/utils/rest";
import { getPartiesList } from "../utils/associatedHelper";

export const getOrganisationsParties = (
  personId: string,
): Promise<AssociatedPartiesItem[]> => {
  const url = `hubwise-api/aml/investors/${personId}/organisations`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(associatedPartiesRequestTransformer);
  });
};
